import Base from '../Base';
export default class Newsletter extends Base {
    init(id, main, locale) {
        console.log(':: Newsletter ::');

        $('#submit_cyberimpact_subscribe').click(e=> {
            e.preventDefault();
            var groups = $('.group_checkbox:checked').map(function() {
                return $(this).val();
            }).get()
                .join();
            $('#ci_groups').val(groups);
            var email = $('#ci_email').val();
            if (groups == '') {
                $('.error_message.groups').css('display', 'block');
            } else if (email == '') {
                $('.error_message.groups').css('display', 'none');
                $('.error_message.email').css('display', 'block');
            } else {
                $('.error_message.email').css('display', 'none');
                $('#cyberimpact_subscribe_form').submit();
            }
        });
    }
}